<template>
  <div class="wl-index">
    <b-overlay :show="loading">
      <div class="wl-header-bar">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="d-inline">My Wine Lists</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="wl-body">
        <div class="container">
          <div class="row">
            <div class="col">
              <table class="table">
                <thead>
                  <tr>
                    <th>Customer Name</th>
                    <th>List Name</th>
                    <th>Date Created</th>
                    <th>Date Updated</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in lists" :key="index">
                    <td>
                      {{ list.customer_details.CardName }} ({{
                        list.customer_details.CardCode
                      }})
                    </td>
                    <td>
                      <b-link :to="'/edit/' + list.slug">{{
                        list.list_title
                      }}</b-link>
                    </td>
                    <td>{{ list.created_at | formatDatetime }}</td>
                    <td>{{ list.updated_at | formatDatetime }}</td>
                    <td class="text-right">
                      <b-button
                        size="sm"
                        variant="link"
                        @click="share(list.slug)"
                        >Share</b-button
                      >
                      <!-- <b-button size="sm" variant="link" v-if="isStaff"
                        >Order Samples</b-button
                      > -->
                      <b-button
                        size="sm"
                        variant="link"
                        v-if="isStaff"
                        @click="duplicate(list.id)"
                        >Duplicate</b-button
                      >
                      <b-button
                        size="sm"
                        variant="link"
                        @click="delete_list(list)"
                        >Delete</b-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col text-center">
              <b-button variant="primary" size="lg" to="/new"
                >Create new Wine List</b-button
              >
            </div>
          </div>
        </div>
      </div>
      <wine-list-share :list-slug="share_slug"></wine-list-share>
    </b-overlay>
  </div>
</template>


<script>
import { mapState } from "vuex";
import WineListShare from "@/components/winelist/WineListShare";

export default {
  components: {
    WineListShare,
  },
  data() {
    return {
      share_slug: "",
      loading: false,
    };
  },
  computed: {
    ...mapState("winelist", ["lists"]),
  },
  methods: {
    delete_list(list) {
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to delete " + list.list_title + "?"
        )
        .then((status) => {
          if (status) {
            this.$store
              .dispatch("winelist/delete_list", { id: list.id })
              .then(() => {
                this.$bvModal.msgBoxOk(list.list_title + " has been deleted.");
              });
          }
        });
    },
    share(slug) {
      this.share_slug = slug;
      this.$bvModal.show("modal-list-share");
    },
    duplicate(id) {
      this.loading = true;
      this.$store
        .dispatch("winelist/duplicate_list", { id })
        .then((response) => {
          this.loading = false;
          this.$router.push("/settings/" + response.data.slug);
        });
    },
  },
};
</script>
